import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarComponent } from "./Sidebar";
import { NavbarComponent } from "./Navbar";
import { Button, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import useApi from "../hooks/useApi";
import configureService from "../api/services/configureService";
import ConfigHeader from "../views/PostLogin/Configure/ConfigHeader";
import { useDispatch } from "react-redux";
import { clearUser } from "../redux/slices/userSlice";

const Dashboard = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginData = JSON.parse(localStorage.getItem("loginData" || "{}"));
  const [advertiserId, setAdvertiserId] = useState(null);
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [advertisersList, setAdvertisersList] = useState([]);
  const [selectedAdvertiser, setSelectedAdvertiser] = useState("");
  const [meta_followers, setMetaFollowers] = useState("");
  const [insta_followers, setInsFollowers] = useState("");
  const [advLogo, setAdvLogo] = useState(null);
  const [dataIngestionStatus, setDataIngestionStatus] = useState(null);
  const [googleIngestionStatus, setGoogleIngestionStatus] = useState(null);
  const [optIngestionStatus, setOptIngestionStatus] = useState(null);
  const [search, setSearch] = useState("");
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  const { callApi: getAdvertisers } = useApi(
    configureService.getAdvertisers,
    null,
    false
  );
  useEffect(() => {
    if (
      advertiserId ||
      dataIngestionStatus ||
      googleIngestionStatus ||
      optIngestionStatus ||
      // startDate ||
      // endDate ||
      selectedAdvertiser ||
      advLogo ||
      meta_followers ||
      insta_followers
    ) {
      const data = {
        advertiserId: advertiserId || "",
        dataIngestionStatus: dataIngestionStatus || "",
        googleIngestionStatus: googleIngestionStatus || "",
        optIngestionStatus: optIngestionStatus || "",
        // startDate: startDate || "",
        // endDate: endDate || "",
        selectedAdvertiser: selectedAdvertiser || "",
        advLogo: advLogo || "",
        meta_followers: meta_followers || "",
        insta_followers: insta_followers || "",
      };

      localStorage.setItem(advertiserId, JSON.stringify(data));
    }
  }, [
    advertiserId,
    dataIngestionStatus,
    googleIngestionStatus,
    optIngestionStatus,
    // startDate,
    // endDate,
    selectedAdvertiser,
    advLogo,
    meta_followers,
    insta_followers,
  ]);

  const memoizedGetAdvertisers = useCallback(getAdvertisers, [getAdvertisers]);
  useEffect(() => {
    if (location.pathname !== "/export-pdf") {
      memoizedGetAdvertisers(
        { user_id: loginData?.id, search: search },
        (response) => {
          if (response?.data?.result) {
            let advertisers = response?.data?.result?.rows || [];
            if (loginData?.email === "demo@prism.com") {
              advertisers = advertisers.filter(
                (adv) =>
                  adv.advertiser_id === "1677b400-8037-4b67-87f2-fc359750386b"
              );
            }
            const firstActiveAdvertiser = advertisers?.find(
              (advertiser) => advertiser?.is_active
            );

            const storedAdvertiser = localStorage.getItem("currentAdv");
            // console.log("stored avertiser====", JSON.parse(storedAdvertiser))
            if (storedAdvertiser) {
              // to set previously selected advertiser even on page refresh
              const parsedData = JSON.parse(storedAdvertiser);
              setAdvertisersList(advertisers);
              setAdvertiserId(parsedData?.advertiser_id || "");
              setSelectedAdvertiser(
                parsedData?.advertiser_name || "Advertiser"
              );
              setMetaFollowers(
                parsedData?.advertiser_data_config_details?.[0]
                  ?.meta_followers || ""
              );
              setInsFollowers(
                parsedData?.advertiser_data_config_details?.[0]
                  ?.insta_followers || ""
              );
              setAdvLogo(parsedData?.logo || "");
              setDataIngestionStatus(
                parsedData?.data_ingestion_statuses?.length
                  ? parsedData.data_ingestion_statuses[0].status
                  : null
              );
              setGoogleIngestionStatus(
                parsedData?.google_data_ingestion_statuses?.length
                  ? parsedData.google_data_ingestion_statuses[0].status
                  : null
              );
              setOptIngestionStatus(
                parsedData?.opti_data_ingestion_statuses?.length
                  ? parsedData.opti_data_ingestion_statuses[0].status
                  : null
              );
              // setStartDate(
              //   parsedData?.advertiser_data_config_details?.[0]?.start_date || ""
              // );
              // setEndDate(
              //   parsedData?.advertiser_data_config_details?.[0]?.end_date || ""
              // );
            } else if (firstActiveAdvertiser) {
              setAdvertisersList(advertisers);
              setAdvertiserId(firstActiveAdvertiser?.advertiser_id);
              setSelectedAdvertiser(firstActiveAdvertiser?.advertiser_name);
              setMetaFollowers(
                firstActiveAdvertiser?.advertiser_data_config_details?.length
                  ? firstActiveAdvertiser?.advertiser_data_config_details[0]
                      ?.meta_followers
                  : null
              );
              setInsFollowers(
                firstActiveAdvertiser?.advertiser_data_config_details[0]
                  ?.insta_followers
              );
              setAdvLogo(firstActiveAdvertiser?.logo);
              setDataIngestionStatus(
                firstActiveAdvertiser.data_ingestion_statuses &&
                  firstActiveAdvertiser.data_ingestion_statuses.length > 0
                  ? firstActiveAdvertiser.data_ingestion_statuses[0].status
                  : null
              );
              setGoogleIngestionStatus(
                firstActiveAdvertiser?.google_data_ingestion_statuses?.length
                  ? firstActiveAdvertiser.google_data_ingestion_statuses[0]
                      .status
                  : null
              );
              setOptIngestionStatus(
                firstActiveAdvertiser?.opti_data_ingestion_statuses?.length
                  ? firstActiveAdvertiser.opti_data_ingestion_statuses[0].status
                  : null
              );
              // setStartDate(
              //   firstActiveAdvertiser?.advertiser_data_config_details[0]
              //     ?.start_date
              // );
              // setEndDate(
              //   firstActiveAdvertiser?.advertiser_data_config_details[0]?.end_date
              // );
            } else {
              console.warn("No active advertiser found.");
            }
          }
        }
      );
    }
    // eslint-disable-next-line
  }, [memoizedGetAdvertisers, search]);
  const handleApiSuccess = useCallback(() => {
    const advertiserData = JSON.parse(localStorage.getItem("currentAdv"));
    const currentAdvId = advertiserData?.advertiser_id || advertiserId;

    memoizedGetAdvertisers(
      { user_id: loginData?.id, search: search },
      (response) => {
        if (response?.data?.result) {
          const advertisers = response?.data?.result?.rows;

          const updatedAdvertiser = advertisers.find(
            (adv) => adv.advertiser_id === currentAdvId
          );

          if (updatedAdvertiser) {
            // Update states
            setAdvertisersList(advertisers);
            setAdvertiserId(updatedAdvertiser?.advertiser_id);
            setSelectedAdvertiser(updatedAdvertiser?.advertiser_name);
            setMetaFollowers(
              updatedAdvertiser?.advertiser_data_config_details?.[0]
                ?.meta_followers || ""
            );
            setInsFollowers(
              updatedAdvertiser?.advertiser_data_config_details?.[0]
                ?.insta_followers || ""
            );
            setAdvLogo(updatedAdvertiser?.logo);
            setDataIngestionStatus(
              updatedAdvertiser?.data_ingestion_statuses?.[0]?.status || null
            );
            setGoogleIngestionStatus(
              updatedAdvertiser?.google_data_ingestion_statuses?.[0]?.status ||
                null
            );
            setOptIngestionStatus(
              updatedAdvertiser?.opti_data_ingestion_statuses?.[0]?.status ||
                null
            );
            // setStartDate(
            //   updatedAdvertiser?.advertiser_data_config_details?.[0]
            //     ?.start_date || ""
            // );
            // setEndDate(
            //   updatedAdvertiser?.advertiser_data_config_details?.[0]?.end_date ||
            //     ""
            // );
            localStorage.setItem(
              "currentAdv",
              JSON.stringify(updatedAdvertiser)
            );
          } else {
            console.warn("Matching advertiser not found for ID:", currentAdvId);
          }
        }
      }
    );
  }, [advertiserId, memoizedGetAdvertisers, loginData?.id, search]);

  const toggleSidebar = () => {
    setSidebarOpen((prevState) => !prevState);
  };

  // useEffect(() => {
  //   const handleMouseMove = (e) => {
  //     const threshold = window.innerWidth * 0.05;
  //     console.log(threshold);
  //     if (e.clientX > threshold) {
  //       setSidebarOpen(true);
  //     } else {
  //       setSidebarOpen(false);
  //     }
  //   };

  //   window.addEventListener("mousemove", handleMouseMove);
  //   return () => window.removeEventListener("mousemove", handleMouseMove);
  // }, []);

  const handleLogout = () => {
    navigate("/login");
    setOpenModal(false);
    localStorage.clear();
    dispatch(clearUser());
    // localStorage.removeItem("loginData");
  };
  const memoizedChildren = React.useMemo(
    () =>
      React.Children.map(children, (child) =>
        React.cloneElement(child, {
          advertiserId,
          dataIngestionStatus,
          googleIngestionStatus,
          optIngestionStatus,
          // startDate,
          // endDate,
          handleApiSuccess,
          advLogo,
          selectedAdvertiser,
          loginData,
        })
      ),
    [
      children,
      advertiserId,
      dataIngestionStatus,
      googleIngestionStatus,
      optIngestionStatus,
      // startDate,
      // endDate,
      handleApiSuccess,
      advLogo,
      selectedAdvertiser,
      loginData,
    ]
  );

  const location = useLocation();
  const excludeHeader =
    location.pathname === "/configure-form" ||
    location.pathname === "/configure-optimization" ||
    location.pathname === "/configure-benchmark" ||
    location.pathname === "/configure" ||
    location.pathname === "/config-users" ||
    location.pathname === "/export-pdf" ||
    location.pathname === "/google-export-pdf" ||
    location.pathname === "/media-export-pdf";
  const excludeSidebar =
    location.pathname === "/export-pdf" ||
    location.pathname === "/google-export-pdf" ||
    location.pathname === "/media-export-pdf";
  const excludeConfigHeader =
    location.pathname === "/configure-form" ||
    location.pathname === "/export-pdf" ||
    location.pathname === "/google-export-pdf" ||
    location.pathname === "/media-export-pdf";

  useEffect(() => {
  
   if (window.innerWidth < 1024) {
    setSidebarOpen(true);
  }

}, [location.pathname]);


  return (
    <div className={`wrapper ${isSidebarOpen ? "closed" : "expanded"}`}>
      <div onClick={toggleSidebar} className="sidebar-overlay lg:hidden"></div>
      {!excludeSidebar && (
        <SidebarComponent
          isOpen={isSidebarOpen}
          onToggleSidebar={toggleSidebar}
          setOpenModal={setOpenModal}
          loginData={loginData}
        />
      )}

      {/* <div
        className={`rightContainer duration-300 flex-1 ${
          isSidebarOpen ? "expanded" : "rightColl"
        }`}
      > */}
      <div className="rightContainer duration-300">
        {!excludeHeader && (
          <NavbarComponent
            isOpen={isSidebarOpen}
            onToggleSidebar={toggleSidebar}
            advertisersList={advertisersList}
            setAdvertiserId={setAdvertiserId}
            advertiserId={advertiserId}
            setSelectedAdvertiser={setSelectedAdvertiser}
            setMetaFollowers={setMetaFollowers}
            setInsFollowers={setInsFollowers}
            setAdvLogo={setAdvLogo}
            selectedAdvertiser={selectedAdvertiser}
            meta_followers={meta_followers}
            insta_followers={insta_followers}
            advLogo={advLogo}
            // setStartDate={setStartDate}
            // setEndDate={setEndDate}
            setDataIngestionStatus={setDataIngestionStatus}
            setGoogleIngestionStatus={setGoogleIngestionStatus}
            setOptIngestionStatus={setOptIngestionStatus}
            search={search}
            setSearch={setSearch}
          />
        )}

        {excludeHeader && !excludeConfigHeader && <ConfigHeader />}

        {/* <div className="p-4 sectionWrap">{children}</div> */}
        <div className="p-4 sectionWrap">{memoizedChildren}</div>
      </div>
      <Modal
        show={openModal}
        size="md"
        onClose={() => setOpenModal(false)}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to Logout?
            </h3>
            <div className="flex justify-center gap-4">
              <Button color="failure" onClick={handleLogout}>
                {"Yes, I'm sure"}
              </Button>
              <Button color="gray" onClick={() => setOpenModal(false)}>
                No, cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Dashboard;
